import { render, staticRenderFns } from "./confirmOrderModal.vue?vue&type=template&id=63cc013e&scoped=true&"
import script from "./confirmOrderModal.vue?vue&type=script&lang=js&"
export * from "./confirmOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./confirmOrderModal.vue?vue&type=style&index=0&id=63cc013e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc013e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63cc013e')) {
      api.createRecord('63cc013e', component.options)
    } else {
      api.reload('63cc013e', component.options)
    }
    module.hot.accept("./confirmOrderModal.vue?vue&type=template&id=63cc013e&scoped=true&", function () {
      api.rerender('63cc013e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/confirmOrderModal.vue"
export default component.exports